import { createAction, props } from '@ngrx/store';
import { IUploadDocsParams } from '../models/IUploadDocsParams.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadGetUploadedDocs = createAction('[GetUploadedDoc] Load GetUploadedDocs', props<{ request: IUploadDocsParams }>());

export const loadGetUploadedDocsSuccess = createAction('[GetUploadedDoc] Load GetUploadedDocs Success', props<{ response: boolean }>());

export const loadGetUploadedDocsFailure = createAction(
  '[GetUploadedDoc] Load GetUploadedDocs Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//---------------------SAVE UPLOAD TO STORE
export const saveUploadedFileToStore = createAction('[GetUploadedDoc] save file to store request', props<{ savedBase64: string }>());
